export interface ITrackingDiagnostic {
  id: string
  bundleId: string
  requesterId: string
  requesterEmail: string
  organizationId: string
  organizationName: string
  sessionId: string
  sessionType: string
  type: string
  description: string
  addedAtUtc: string
  updatedAtUtc: string
  deletedAtUtc: string | null

  // Entry's Properties
  measurementId: string
  radarSerial: string
  uploadedAtUtc: string | null
  hasFile: boolean
  failureReason: string | null
  cancelledAtUtc: string | null
}

export enum TrackingDiagnosticsTag {
    None = 0,
    BadData = 1,
    MissingData = 2,
    Trajectory = 3,
    WallImpact = 4,
    StartPosition = 5,
    Result = 6,
    BadTrigger = 7,
    GhostShot = 8,
    Test = 9,
}

export interface ITrackingDiagnosticsRequestDto {
  updatedAfter: string
  includeDeleted: boolean,
  pageSize: number,
  page: number
}

export interface ICreateFtmfRequest {
  requesterId: string;
  organizationId: string;
  sessionId: string;
  type: string;
  description: string;
  entries: ICreateFtmfEntryRequest[];
}

export interface ICreateFtmfEntryRequest {
  measurementId: string;
  calibrationId: string;
}

export interface IMeasurementBodyContext {
  sessionId: string | null;
  measurementId: string | null;
  calibrationId: string | null;
}